import { collectHelpCrunchCustomData } from './customData';

import type { HelpCrunchCustomData } from './customData';

declare global {
  interface Window {
    HelpCrunch?: (command: string, ...args: unknown[]) => void;
  }
}

const CONTACT_FIELDS = ['email', 'name', 'phone', 'company'] as const;

type HelpCrunchContact = Partial<
  Record<(typeof CONTACT_FIELDS)[number], string>
>;

type HelpCrunchEvent = 'onChatOpen' | 'onPreChatFormSubmit';

const updateHelpCrunchUser = (
  customData: HelpCrunchCustomData,
  contact: HelpCrunchContact,
): boolean => {
  if (typeof window.HelpCrunch !== 'function') return false;

  try {
    window.HelpCrunch('updateUser', { ...contact, custom_data: customData });
    return true;
  } catch {
    return false;
  }
};

const onHelpCrunch = (
  event: HelpCrunchEvent,
  handler: (payload: unknown) => void,
): boolean => {
  if (typeof window.HelpCrunch !== 'function') return false;

  try {
    window.HelpCrunch(event, handler);
    return true;
  } catch {
    return false;
  }
};

const readRecord = (value: unknown, key: string): unknown =>
  typeof value === 'object' && value !== null
    ? Reflect.get(value, key)
    : undefined;

const contactFromPreChatForm = (payload: unknown): HelpCrunchContact => {
  const userData = readRecord(readRecord(payload, 'detail'), 'userData');
  const contact: HelpCrunchContact = {};

  CONTACT_FIELDS.forEach((field) => {
    const value = readRecord(userData, field);
    if (typeof value === 'string' && value) contact[field] = value;
  });

  return contact;
};

let lastSent = '';

export const syncHelpCrunchAttribution = (
  contact: HelpCrunchContact = {},
): void => {
  const customData = collectHelpCrunchCustomData();
  const fingerprint = JSON.stringify([customData, contact]);

  if (fingerprint === lastSent) return;

  if (updateHelpCrunchUser(customData, contact)) lastSent = fingerprint;
};

let listening = false;

export const listenToHelpCrunch = (): void => {
  if (listening) return;

  listening =
    onHelpCrunch('onChatOpen', () => syncHelpCrunchAttribution()) &&
    onHelpCrunch('onPreChatFormSubmit', (payload) =>
      syncHelpCrunchAttribution(contactFromPreChatForm(payload)),
    );
};
